import { isServerPlayerCondition, type PlayerConditionSnapshot, type ServerPlayerCondition } from "@endclock/shared";

/** The only client owner of private medical state. Presentation never integrates physiology. */
export class PlayerConditionStore {
  private current: PlayerConditionSnapshot | null = null;
  private readonly listeners = new Set<(snapshot: PlayerConditionSnapshot | null) => void>();
  get snapshot(): PlayerConditionSnapshot | null { return this.current; }
  ingest(message: ServerPlayerCondition): boolean {
    if (!isServerPlayerCondition(message) || this.current && message.revision <= this.current.revision) return false;
    this.current = Object.freeze({ revision: message.revision, at: message.at,
      vitals: Object.freeze({ ...message.vitals }),
      modifiers: Object.freeze({ ...message.modifiers }),
      body: Object.freeze(message.body.map(region => Object.freeze({ ...region }))),
      bones: Object.freeze(message.bones.map(bone => Object.freeze({ ...bone }))),
      injuries: Object.freeze(message.injuries.map(injury => Object.freeze({ ...injury }))) });
    this.emit();
    return true;
  }
  /** Reset on a new connection generation before accepting that owner's full snapshot. */
  reset(): void { this.current = null; this.emit(); }
  subscribe(listener: (snapshot: PlayerConditionSnapshot | null) => void): () => void {
    this.listeners.add(listener); listener(this.current);
    return () => { this.listeners.delete(listener); };
  }
  private emit(): void { for (const listener of this.listeners) listener(this.current); }
}
